<template>
  <router-view />
</template>

<style lang="scss">
/* 在全局样式文件中覆盖 */

:root {
  --el-text-color-placeholder: #535353 !important; /* 修改为你想要的颜色 */
  // 这是table选择框的颜色
  --el-border: var(--el-border-width) var(--el-border-style) #535353 !important;
}
p {
  margin: 0;
}



.form-box-line {
  display: flex;
  padding: 16px;
  flex-wrap: wrap;
}

.el-form-item__label {
  line-height: normal !important;
  align-items: center !important;

  &:before {
    content: "" !important;
    margin: 0;
  }
}

.form-box-1 {
  display: grid;
  padding: 16px;
  min-width: 300px;
  grid-template-columns: 1fr;
  gap: 16px;
  box-sizing: border-box;
  text-align: left;
}

.form-box-2 {
  width: 100%;
  display: grid;
  // 平均分布2列
  grid-template-columns: 1fr 1fr;
  padding: 16px;
  box-sizing: border-box;
  text-align: left;
  gap: 16px;
}

.form-item-1 {
  grid-column: 1 / -1;
}

.form-box-3 {
  display: grid;
  grid-template-columns: 300px 300px 300px;
  padding: 16px;
  box-sizing: border-box;
  text-align: left;
  gap: 16px;
}
.clickForDetails {
  cursor: pointer;
  color: #409eff;
  font-weight: 600;
}
// dialog 弹框关闭按钮大小
.el-dialog__headerbtn {
  font-size: 35px !important; /* 调整按钮大小 */
}
</style>

<script>
</script>
